export default __webpack_public_path__ + "static/media/829.1602ea0c.jpg";